export default __webpack_public_path__ + "static/media/checkPresentation.e0083fb8.mp4";